import type * as core from '../../../../../../../core'

export const query: core.mosaic.Action.Query = {
  selection: {
    '{}': {
      payload: {
        '{}': {
          insertion: {
            '{}': {
              modelId: 'ent:!subawards:!subaward',
              inputs: {
                '{}': {
                  records: {
                    '[]': [
                      {
                        '{}': {
                          values: {
                            '{}': {
                              '!id': {
                                '@$': 'subawardId',
                              },
                              '!code': {
                                '@$': 'subawardCode',
                              },
                              '!name': {
                                '@$': 'subawardName',
                              },
                              '!subrecip': {
                                '@$': 'subawardSubrecip',
                              },
                              '!subrecip_pi': {
                                '??': [
                                  {
                                    '@$': 'subawardSubrecipPi',
                                  },
                                  null,
                                ],
                              },
                              '!proj': {
                                '@$': 'subawardProj',
                              },
                              '!admin_contact': {
                                '??': [
                                  {
                                    '@$': 'subawardAdminContact',
                                  },
                                  {
                                    '{}': {},
                                  },
                                ],
                              },
                              '!invoice_contact': {
                                '??': [
                                  {
                                    '@$': 'subawardInvoiceContact',
                                  },
                                  {
                                    '{}': {},
                                  },
                                ],
                              },
                              '!authorized_contact': {
                                '??': [
                                  {
                                    '@$': 'subawardAuthorizedContact',
                                  },
                                  {
                                    '{}': {},
                                  },
                                ],
                              },
                              '!budget_period': {
                                '@$': 'subawardBudgetPeriod',
                              },
                              '!curr_amount': {
                                '@$': 'subawardCurrAmount',
                              },
                              '!total_amount': {
                                '@$': 'subawardTotalAmount',
                              },
                              '!perf_address': {
                                '??': [
                                  {
                                    '@$': 'subawardPerfAddress',
                                  },
                                  {
                                    '{}': {},
                                  },
                                ],
                              },
                              '!admin_address': {
                                '??': [
                                  {
                                    '@$': 'subawardAdminAddress',
                                  },
                                  {
                                    '{}': {},
                                  },
                                ],
                              },
                              '!pay_address': {
                                '??': [
                                  {
                                    '@$': 'subawardPayAddress',
                                  },
                                  {
                                    '{}': {},
                                  },
                                ],
                              },
                              '!fin_contact': {
                                '??': [
                                  {
                                    '@$': 'subawardFinContact',
                                  },
                                  {
                                    '{}': {},
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
            },
          },
        },
      },
      operation: 'dms.mutate',
    },
  },
}
